import { LoggerName, namedLogger } from '../../../../../../utils/logger'

const logger = namedLogger(LoggerName.VideoPlaceholdersTracker)

/**
 * Tracks video placeholder elements by their names as they are built in the DOM.
 */
export class VideoPlaceholdersTracker {
  public videoPlaceholdersByName: Map<string, HTMLElement[]> = new Map()

  public track(placeholderName: string, placeholderEl: HTMLElement) {
    logger.debug('tracking video placeholder -', placeholderName, { console: { placeholderEl } })
    const placeholders = this.videoPlaceholdersByName.get(placeholderName) || []
    placeholders.push(placeholderEl)
    this.videoPlaceholdersByName.set(placeholderName, placeholders)
  }

  public findPlaceholder(placeholderName: string, doc: Document) {
    const placeholders = this.videoPlaceholdersByName.get(placeholderName)
    if (placeholders) {
      const result = placeholders.find(el => el.isConnected)
      if (result) {
        this.videoPlaceholdersByName.set(placeholderName, [result])
      }
      return result
    }

    if (doc) {
      const result = doc.querySelector(`[data-rrweb-video-placeholder-name="${placeholderName}"]`) as HTMLElement | undefined
      if (result) {
        this.videoPlaceholdersByName.set(placeholderName, [result])
      }
      return result
    }
  }

  public clear() {
    this.videoPlaceholdersByName.clear()
  }
}
